// extracted by mini-css-extract-plugin
module.exports = {"fs18":"n5-scroll-top-button-module--fs18--ie62R","fs26":"n5-scroll-top-button-module--fs26--3vaPr","backToTop":"n5-scroll-top-button-module--backToTop--JkPTg"};